<template>
  <div>
    <default-modal
      ref="box"
      :title="title"
      :modalWidth="600"
      :confirmTxt="`保存`"
      @confirm="confirm"
    >
      <div class="content">
        <div
          class="commonLine"
          v-show="type != 2"
        >
          <div class="left">
            <span>网吧名称：</span>
          </div>
          <div class="right">
            <input
              type="text"
              v-model="barName"
              placeholder="长度4-16个字符，支持中英文、符号"
            />
          </div>
        </div>
        <div
          class="commonLine"
          v-show="type != 2"
        >
          <div class="left">
            <span>放置分组：</span>
          </div>
          <div class="right">
            <select
              name="groupListEditBarInfo"
              v-model="groupId"
              class="sel1"
            >
              <option
                v-for="(item, index) in groupList"
                :value="item.groupId"
                v-text="item.groupName"
                :key="index"
              ></option>
            </select>
          </div>
        </div>
        <div
          class="commonLine"
          v-show="type != 2"
        >
          <div class="left">
            <span>所在区域：</span>
          </div>
          <div class="right sel2">
            <city-selector ref="citySelector"></city-selector>
          </div>
        </div>
        <div
          class="commonLine"
          v-show="type != 1"
        >
          <div class="left">
            <span>网吧登录密码：</span>
          </div>
          <div class="right">
            <input
              type="password"
              v-model="barPassword"
              placeholder="长度6-16位数字、英文大小写、符号任意两种以上组合"
            />
          </div>
        </div>
        <div
          class="commonLine"
          v-show="type != 1"
        >
          <div class="left">
            <span>确认密码：</span>
          </div>
          <div class="right">
            <input
              type="password"
              v-model="barVerPassword"
              placeholder="再次输入密码"
            />
          </div>
        </div>
      </div>
    </default-modal>
  </div>
</template>

<script>
import DefaultModal from "_c/modals/defaultModal";
import CitySelector from "_c/selector/citySelector";

import {
  registerBar,
  getEditBarInfo,
  updateBarInfo,
  changeBarPwd
} from "@/requests/bar";

import { mapState, mapActions } from "vuex";

export default {
  name: "barModals",
  components: {
    CitySelector,
    DefaultModal
  },
  data() {
    return {
      type: "", //0:注册网吧,1:修改网吧,2:修改密码
      barId: "",
      // 选中的groupId
      groupId: "",
      barName: "",
      barPassword: "",
      barVerPassword: "",
      barCityid: "",
      successFn: ""
    };
  },
  computed: {
    ...mapState({
      groupList: state => state.user.barGroupList
    }),
    /* eslint-disable */
    title() {
      if (this.type == 0) {
        return `注册网吧ID`;
      }
      if (this.type == 1) {
        return `修改网吧信息`;
      }
      if (this.type == 2) {
        return `修改网吧密码`;
      }
    }
  },
  mounted() {
    window.$modal.editBarInfo = {};
    window.$modal.editBarInfo.show = ({ type, barId }) => {
      this.type = type;
      this.barId = barId;
      return new Promise(resolve => {
        this.init(() => {
          resolve(true);
        });
      });
    };
    //监听键盘按键事件
    let self = this;
    this.$nextTick(function () {
      document.addEventListener('keyup', function (e) {
        //此处填写你的业务逻辑即可
        if (e.keyCode == 27) {
          self.$refs.box.hide();
        }
      })
    })
  },
  methods: {
    ...mapActions(["user/actionUpdateBarGroupList"]),
    init(fn) {
      this.$refs.box.setWrong("");
      this["user/actionUpdateBarGroupList"]();
      if (this.type == 0) {
        this.$refs.citySelector.init({});
      }
      if (this.type != 0) {
        this.getEditBarInfo(this.barId);
      }
      this.$refs.box.show();
      this.successFn = fn;
    },
    async getEditBarInfo(barId) {
      let res = await getEditBarInfo({ barId });
      this.groupId = res.groupId ? res.groupId : "";
      this.barName = res.barName ? res.barName : "";
      // this.barPassword = res.barPassword ? res.barPassword : ''
      this.barCityid = res.barCityid ? res.barCityid.toString() : "";
      this.$refs.citySelector.init({
        grepA: this.barCityid.substring(0, 2),
        grepB: this.barCityid.substring(0, 4),
        grepC: this.barCityid
      });
    },
    async confirm() {
      let vdt;
      if (this.type == 0 || this.type == 1) {
        // 校验网吧名
        vdt = this.$validateCenter.barName(this.barName);
        if (!vdt.res) {
          return this.$refs.box.setWrong(vdt.msg);
        }
        // 校验分组
        if (!this.groupId) {
          return this.$refs.box.setWrong("请选择放置分组");
        }
        // 校验区域
        if (!this.$refs.citySelector.getRes()) {
          return this.$refs.box.setWrong("请选择所在区域");
        }
      }
      if (this.type == 0 || this.type == 2) {
        // 密码校验
        // vdt = this.$validateCenter.passwordWhds(this.barPassword)
        // if (!vdt.res) {
        //     return this.$refs.box.setWrong(vdt.msg)
        // }
        if (this.barPassword == "") {
          return this.$refs.box.setWrong("密码不能为空");
        }
        if (
          this.barPassword.length < 6 ||
          this.barPassword.length > 16
        ) {
          return this.$refs.box.setWrong("密码长度在6-16之间");
        }
        if (this.barPassword.trim() != this.barVerPassword) {
          return this.$refs.box.setWrong("密码两次输入不一致");
        }
      }
      let res;
      // 注册
      if (this.type == 0) {
        res = await registerBar({
          barId: this.barId,
          barName: this.barName,
          barPassword: this.barPassword,
          barVerPassword: this.barVerPassword,
          groupId: this.groupId,
          barCityid: this.$refs.citySelector.getRes()
        });
      }
      // 修改信息
      if (this.type == 1) {
        res = await updateBarInfo({
          barId: this.barId,
          barName: this.barName,
          groupId: this.groupId,
          barCityid: this.$refs.citySelector.getRes()
        });
      }
      // 修改密码
      if (this.type == 2) {
        res = await changeBarPwd({
          barId: this.barId,
          barPassword: this.barPassword,
          barVerPassword: this.barVerPassword
        });
      }
      if (res.code == 200) {
        this.$refs.box.hide();
        this.successFn();
      } else {
        return this.$refs.box.setWrong(res.msg);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "_style/msgbox/_msgBox.scss";
@import "_style/msgbox/_comMsg.scss";

.content {
  // height: 160px;
  padding-top: 20px;
  padding-bottom: 30px;
}
</style>
